import React from "react";
import { useTheme } from "@mui/material/styles";

const StatusCompletedIcon = ({ color }) => {
  const theme = useTheme();
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="9" fill={color || theme.palette.success[500]}/>
      <path d="M5.355 9L7.785 11.43L12.645 6.57" stroke={theme.palette.system[0]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default StatusCompletedIcon;
